//------ 命令结束显示设计树 开始------
import {
  EditorPanelEventName,
  EditorPanelShowDesignTreeReason,
  useDispatchEvent,
  type EditorPanelShowDesignTreeRequestedEventPayload,
} from '@puppycad/cad-core';

/**
 * 请求编辑器右侧面板切换到设计树。
 *
 * 设计说明：
 * 1. 命令收口方只发布“应回到设计树”的意图，不直接持有右侧 tab 响应式状态；
 * 2. Editor.vue 统一监听 cad-core 事件并完成实际切换，避免各命令模块散落 UI tab 写入。
 *
 * @param reason 本次请求的触发原因。
 * @param command 触发请求时正在收口的命令标识。
 */
export function requestEditorDesignTreeTab(
  reason: EditorPanelShowDesignTreeReason,
  command: string | null,
): void {
  const payload: EditorPanelShowDesignTreeRequestedEventPayload = {
    reason,
    command,
  };

  // 通过 cad-core 事件总线广播右侧面板切换意图，由 Editor.vue 监听后切换 tab。
  useDispatchEvent(EditorPanelEventName.ShowDesignTreeRequested, payload);
}
//------ 命令结束显示设计树 结束------
